import rightImg from "images/about-hero-right.png";
import videoplayback from "images/videoplayback.mp4";
import React, { FC, Fragment, useState, useEffect, useRef } from "react";

import { Helmet } from "react-helmet";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";

import SectionClientSay from "components/SectionClientSay/SectionClientSay";

import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";
const { REACT_APP_SITE_KEY } = process.env;
export interface PagePartnersProps {
  className?: string;
  autoFocus?: boolean;
}
const PagePartners: FC<PagePartnersProps> = ({
  className = "",
  autoFocus = false
}) => {

  const [details, setDetails] = useState({
    name: "",
    email: "",
    contactnumber: "",
    subject: "Keep in Touch with Tiny Away",
    message: "",
    google_captcha: ""
  });
  const [showPopover, setShowPopover] = useState(autoFocus);
  const [description, setDescription] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [bannnerUrl, setBannnerUrl] = useState("");
  const [isVideo, setIsVideo] = useState("");
  const [isImages, setIsImages] = useState("no");
  const [isdataLoaded, setIsdataLoaded] = useState(false);
  const NameRef = useRef<HTMLInputElement>(null);
  const EmailRef = useRef<HTMLInputElement>(null);
  const ContactNumberRef = useRef<HTMLInputElement>(null);
  const SubjectRef = useRef<HTMLInputElement>(null);
  const MessagesRef = useRef<HTMLInputElement>(null);
  const captchaRef = useRef<ReCAPTCHA>(null);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');


  useEffect(() => {
    axios.get(process.env.REACT_APP_BASE_URL + 'getPages?page=about_us')
      .then(res => {
        console.log(res.data);
        setDescription(res.data.page_details.content_html);
        setMetaTitle(res.data.page_details.meta_title);
        setBannnerUrl(res.data.page_details.banner_url);
        setIsVideo(res.data.page_details.is_video);
        setIsImages(res.data.page_details.is_images);
        setIsdataLoaded(true);
      })
  }, [isdataLoaded]);
  const renderskeletonLoader = () => {
    return (
      <div className="custom-loader"><div className="h-screen skeleton"></div></div>
    );
  };


  const submitHandler = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const isInvalid = validateInput();
    if (!isInvalid) {
      //const token = captchaRef.current?.getValue();
      captchaRef.current?.reset();
      // console.log(token);
      //console.log(details.google_captcha);

      axios.post(process.env.REACT_APP_BASE_URL + '/customer_enquiries', details)
        .then(function (response) {
          //console.log(response.data.response);
          if (response.data.status == 200) {
            setSuccessMsg(response.data.response);
            setDetails({
              name: "",
              email: "",
              contactnumber: "",
              subject: "",
              message: "",
              google_captcha: ""
            });
          } else {
            setErrorMsg(response.data.response);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      setSuccessMsg('');
    }
  };
  useEffect(() => {
    //console.log({ showPopover, 'EmailRef': EmailRef.current, 'NameRef': NameRef.current });
    if (showPopover && NameRef.current && !details.name) {
      NameRef.current.focus();
    } else if (showPopover && EmailRef.current && !details.email) {
      EmailRef.current.focus();
    } else if (showPopover && ContactNumberRef.current && !details.contactnumber) {
      ContactNumberRef.current.focus();
    } else if (showPopover && SubjectRef.current && !details.subject) {
      SubjectRef.current.focus();
    } else if (showPopover && MessagesRef.current && !details.message) {
      MessagesRef.current.focus();
    }
  }, [showPopover]);
  const validateInput = () => {
    const fields = [
      {
        name: 'name',
        value: details.name,
        message: 'Your Name should not be blank.'
      },
      {
        name: 'email',
        value: details.email,
        message: 'Your Email should not be blank.'
      },
      {
        name: 'contactnumber',
        value: details.contactnumber,
        message: 'Contact Number should not be blank.'
      },
      {
        name: 'subject',
        value: details.subject,
        message: 'Subject should not be blank.'
      },
      {
        name: 'message',
        value: details.message,
        message: 'Message should not be blank.'
      },
      {
        id: 'google_captcha',
        value: details.google_captcha,
        message: 'Captcha should not be blank.'
      }
    ]
    const isNotFilled = fields.some(field => {
      if (field.value.trim() === '') {
        setErrorMsg(field.message);
        setShowPopover(true);
        return true;
      }
      setShowPopover(false);
      setErrorMsg('');
      return false;
    });
    return isNotFilled;
  };
  function SetRecaptchaVal(value: any) {
    setDetails({ ...details, google_captcha: value });
  }
  const renderCardMenu = () => {
    return (
      <div className="container" >
        <div className="row-wrap">
          <div className="card-list-flex logo-clint">
            <img src="https://tinyawaypartners.my.canva.site/media/a89cac18ff9d04d87fee2dfdc93e7fd7.png" />
          </div>
          <div className="card-list-flex color-white">
            <a href="#page-0" target="_self" draggable="false" rel="noopener">Wellness</a>
          </div>
          <div className="card-list-flex color-yellow">
            <a href="#page-1" target="_self" draggable="false" rel="noopener">Distillery / Brewery /<br />Winery</a>
          </div>
          <div className="card-list-flex color-white">
            <a href="#page-2" target="_self" draggable="false" rel="noopener">Farm</a>
          </div>

          <div className="card-list-flex color-white">
            <a href="#page-3" target="_self" draggable="false" rel="noopener">Activities</a>
          </div>
          <div className="card-list-flex color-yellow">
            <a href="#page-4" target="_self" draggable="false" rel="noopener">Entertainment</a>
          </div>
          <div className="card-list-flex color-white">
            <a href="#page-5" target="_self" draggable="false" rel="noopener">Tour</a>
          </div>
          <div className="card-list-flex color-yellow">
            <a href="#page-6" target="_self" draggable="false" rel="noopener">Restaurant / Cafe /
              Bar</a>
          </div>
        </div>
      </div>
    );
  };
  const renderPageOnscroll0 = () => {
    return (
      <div className="container" id="page-0">
        <div className="row row-flex">
          <div className="col-3 color-yellow"><h1>Wellness</h1></div>
          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/bd69fcfaa8ff99e73fcd0d7e3cbe2007.png" />
              </div>
              <div className="p-max">
                <span className="label">QLD</span>
                <h6>1Monica Arcoya</h6>
                <p>10% discount to all
                  services either 1 on 1
                  session or as a group for
                  Tiny Away guests</p>
                <p>Promocode: <b>Arcoya10</b></p>
              </div>
            </div>
          </div>

          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/7f8e887039a6a44060f2d267393454a0.png" />
              </div>
              <div className="p-max">
                <span className="label">QLD</span>
                <h6>Ulu Flow | Pilates & Yoga
                  Studio</h6>
                <p>Offer a 10% off all single
                  sessions, class packs, and
                  holiday offer for Tiny
                  Away guests</p>
                <p>Promocode: <b>Uluflow10  </b></p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/0917b885b0def6901a80a48b9c6181e2.png" />
              </div>
              <div className="p-max">
                <span className="label">QLD</span>
                <h6>L'Atelier Flow</h6>
                <p>Tiny away guests would
                  have 10% off the below
                  prices: 2wkly classes
                  (including reformer) - $45
                  Unltd classes (including
                  reformer) - $60 and 10%
                  discount on membership
                  fee</p>
                <p>Promocode: <b>Latelierflow10  </b></p>
              </div>
            </div>
          </div>




        </div>

        <div className="row row-flex">
          <div className="col-3 color-yellow"><h1>Wellness</h1></div>
          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/bacdf813ca1c153fe2e9686570830b2c.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-1">NSW</span>
                <h6>Yoga Bare</h6>
                <p>10% discount to yoga
                  classes, pilates, and
                  recovery rooms for Tiny
                  Away Guests</p>
                <p>Promocode: <b>Yogabare10</b></p>
              </div>
            </div>
          </div>

          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/52dadd94ffb7eb2a04f7d1ef503fd1df.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-1">NSW</span>
                <h6>Double Bay Yoga on the
                  Wharf, Sydney</h6>
                <p>10% discount to TA</p>
                <p>Promocode: <b>Doublebayyoga10  </b></p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/b692bce1e2b9321acda125b642cd10ed.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-2">VIC</span>
                <h6>Studio Sukha</h6>
                <p>10 % discount on all
                  casual classes for Tiny
                  Away guests</p>
                <p>Promocode: <b>Sukha10  </b></p>
              </div>
            </div>
          </div>




        </div>
        <div className="row row-flex">
          <div className="col-3 color-yellow"><h1>Wellness</h1></div>
          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/7be4f3ab34c6e9c1cf05f812f50090bc.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-2">VIC</span>
                <h6>EVOL- VE Wellness</h6>
                <p>10% discount on all
                  classes</p>
                <p>Promocode: <b>Evol10</b></p>
              </div>
            </div>
          </div>

          <div className="col-3">
            <div className="coming-soon">Coming soon</div>
          </div>


          <div className="col-3">
            <div className="coming-soon">Coming soon</div>
          </div>




        </div>
      </div>
    );
  };

  const renderPageOnscroll1 = () => {
    return (
      <div className="container" id="page-1">
        <div className="row row-flex">
          <div className="col-3 color-yellow"><h1><div>Distillery / Brewery / Winery</div></h1></div>
          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/d59ec085691daff56f5c9b51574ea777.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-3">SA</span>
                <h6>MollyDooker Wines</h6>
                <p>Offers complimentary
                  Wine tasting for tiny away
                  guests</p>
                <p>Promocode: <b>Mollydooker10</b></p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/1a3a20137c642bb012c4397536e5eced.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-3">SA</span>
                <h6>La Prova</h6>
                <p>Complimentary
                  charcuterie plate with
                  wine tasting</p>
                <p>Promocode: <b>Laprova10</b></p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/64a499e0a5fa93fa2d6570803ccbe837.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-1">NSW</span>
                <h6>Briar Ridge Vineyard</h6>
                <p>Free 'Cellar Door Wine
                  Tasting Experience' for
                  up to 8 guests.

                  10% discount on all other
                  experiences (tours etc)
                  and wine purchases in
                  Cellar Door for Tiny Away
                  guests</p>
                <p>Promocode: <b>BriarRidge10</b></p>
              </div>
            </div>
          </div>

        </div>

        <div className="row row-flex">
          <div className="col-3 color-yellow"><h1><div>Distillery / Brewery / Winery</div></h1></div>
          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/036873d5564267d9f11b4e4c485e1b23.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-1">NSW</span>
                <h6>Bilpin Cider</h6>
                <p>10% discount in all take
                  away Cellar Door sales as
                  well as a 10% discount on
                  a tasting paddle from the
                  bar</p>
                <p>Promocode: <b>Bilpincider10</b></p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/9e32063638ce26fcba3156336d66f378.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-1">NSW</span>
                <h6>Rosnay Cellardoor</h6>
                <p>10% discount in selected
                  wines and 5% discount in
                  glamping and
                  accommodation for Tiny
                  Away guests</p>
                <p>Promocode: <b>Rosnay10</b></p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/d28eec798c2189ffca809ede40afac00.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-1">NSW</span>
                <h6>Two Rivers Wine</h6>
                <p>Offers free wine tastings
                  to Tiny Away guests</p>
                <p>Promocode: <b>Tworiverswine10</b></p>
              </div>
            </div>
          </div>

        </div>




        <div className="row row-flex">
          <div className="col-3 color-yellow"><h1><div>Distillery / Brewery / Winery</div></h1></div>
          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/5fe4dfb1ac36f63cb583bb9ab69654ba.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-4">WA</span>
                <h6>Margies Big Day out</h6>
                <p>Offers Free Wine tasting
                  for Tiny Away guests</p>
                <p>Promocode: <b>Margies10</b></p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/78178efdbcc6453fdf075eba41451e7d.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-4">WA</span>
                <h6>Brown Hill Estate Wine</h6>
                <p>Complimentary wine
                  tasting and offer a 10%
                  discount on any mixed
                  dozen purchased from their
                  cellar door with free
                  shipping within Australia
                  and also provide TA guests
                  a complimentary bottle of
                  wine when they purchase a
                  mixed dozen</p>
                <p>Promocode: <b>Brownhill10</b></p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/1dc816c486765c9d38d1ecc787cedfe0.jpg" />
              </div>
              <div className="p-max">
                <span className="label color-label-1">NSW</span>
                <h6>Cael’s Gate</h6>
                <p>10% discount on all wines
                  for Tiny Away guests.</p>
                <p>Promocode: <b>Caelsgate10</b></p>
              </div>
            </div>
          </div>

        </div>






        <div className="row row-flex">
          <div className="col-3 color-yellow"><h1><div>Distillery / Brewery / Winery</div></h1></div>
          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/ee750c7c3f51c51af0afcbf1dc63b317.jpg" />
              </div>
              <div className="p-max">
                <span className="label color-label-7">TAS</span>
                <h6>Dunalley Bay Distillery -
                  Eat & Drink</h6>
                <p>10% discount on meals
                  and 15% on Gins.</p>
                <p>Promocode: <b>Dunalleybay10</b></p>
              </div>
            </div>
          </div>



          <div className="col-3">
            <div className="coming-soon">Coming soon</div>
          </div>



          <div className="col-3">
            <div className="coming-soon">Coming soon</div>
          </div>

        </div>
      </div>

    );
  };
  const renderPageOnscroll2 = () => {
    return (

      <div className="container" id="page-2">
        <div className="row row-flex">
          <div className="col-3 color-yellow"><h1><div>Farm</div></h1></div>
          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/536945fffb01114afde145d76bba2c6a.png" />
              </div>
              <div className="p-max">
                <span className="label">QLD</span>
                <h6>Farm to Vase </h6>
                <p>10% off via their website
                  for Tiny Away guests</p>
                <p>Promocode: <b>VASE10</b></p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/ec943ca90bfbfab2ad8682684ba3245f.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-2">VIC</span>
                <h6>Avoca Park Equestrian &
                  Farmstay </h6>
                <p>10% discount to casual
                  horse riding lessons for
                  Tiny Away guests

                  5% discount to pony
                  experience for Tiny Away
                  guests

                  10% discount
                  accommodation for Tiny
                  Away guests</p>
                <p>Promocode: <b>Avoca10</b></p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/22f7ea4e78a73e261481b7ae4568b690.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-2">VIC</span>
                <h6>Cornella Farm </h6>
                <p>10% Discount to activities
                  for Tiny Away guests</p>
                <p>Promocode: <b>Corneliafarm10</b></p>
              </div>
            </div>
          </div>





        </div>


        <div className="row row-flex">
          <div className="col-3 color-yellow"><h1><div>Farm</div></h1></div>
          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/3f34b7300ac5b8ddada71fe1910bc8fd.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-2">VIC</span>
                <h6>Rosehaven Farms</h6>
                <p>10% discount on all
                  activities, meals and
                  products.</p>
                <p>Promocode: <b>RosehavenFarms10</b></p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/a51fd856c4715e7a6dee034529390a33.jpg" />
              </div>
              <div className="p-max">
                <span className="label">QLD</span>
                <h6>Beauwood Park</h6>
                <p>10% discount on all
                  products.</p>
                <p>Promocode: <b>Beauwoodpark10</b></p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/c68cd077906b4dbdeb81d343e6c21e0a.jpg" />
              </div>
              <div className="p-max">
                <span className="label color-label-2">VIC</span>
                <h6>Abundance Farm</h6>
                <p>10% discount on all beef
                  orders.</p>
                <p>Promocode: <b>Abundance10</b></p>
              </div>
            </div>
          </div>





        </div>
      </div>
    );
  };
  const renderPageOnscroll3 = () => {
    return (
      <div className="container" id="page-3">
        <div className="row row-flex">
          <div className="col-3 color-yellow"><h1><div>Activities</div></h1></div>
          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/b4c2049c92c861d116cf6faa40f0fe3b.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-3">SA</span>
                <h6>TreeClimb Kuitpo </h6>
                <p>10% discount code on
                  activities</p>
                <p>Promocode: <b>Kuitpo10</b></p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/15e12d54d0edf08fbaf8956c19a92a95.png" />
              </div>
              <div className="p-max">
                <span className="label ">QLD</span>
                <h6>Stunt Park </h6>
                <p>10% discount to Tiny away
                  guests</p>
                <p>Promocode: <b>Stuntpark10</b></p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/c7c644767109798eba4930983d9742ac.png" />
              </div>
              <div className="p-max">
                <span className="label">QLD</span>
                <h6>Fraser Dingo 4WD
                  Adventure</h6>
                <p>10% discount in 4WD tours
                  and 10% discount in Hike
                  tours for Tiny Away
                  guests</p>
                <p>Promocode: <b>Fraser10</b></p>
              </div>
            </div>
          </div>





        </div>

        <div className="row row-flex">
          <div className="col-3 color-yellow"><h1><div>Activities</div></h1></div>
          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/166bc43fe52518704402841173e00dbd.png" />
              </div>
              <div className="p-max">
                <span className="label color-label-5">WA</span>
                <h6>Amaze Miniature Park</h6>
                <p>10% discount entrance fee
                  for Tiny Away guests</p>
                <p>Promocode: <b>Amaze10</b></p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/437460eacdc549466f796aae40c95bab.jpg" />
              </div>
              <div className="p-max">
                <span className="label color-label-2">VIC</span>
                <h6>Natalia Pedan Artworks </h6>
                <p>10% discount on all
                  artworks and workshops.</p>
                <p>Promocode: <b>Nataliapedanart10</b></p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="cont-text-mid">
              <div className="box-logo">
                <img src="https://tinyawaypartners.my.canva.site/media/a9557e5063aaea3607a548c20110da61.jpg" />
              </div>
              <div className="p-max">
                <span className="label color-label-1">NSW</span>
                <h6>Advance College

                </h6>
                <p>10% discount on all
                  courses.</p>
                <p>Promocode: <b>Advancecollege10</b></p>
              </div>
            </div>
          </div>





        </div>
      </div>
    );
  };
  const renderPageOnscroll4 = () => {
    return ( 
      <div className="container" id="page-5">
      <div className="row row-flex">
        <div className="col-3 color-yellow"><h1><div>Tour</div></h1></div>
        <div className="col-3">
          <div className="cont-text-mid">
            <div className="box-logo">
              <img src="https://tinyawaypartners.my.canva.site/media/98561a68af42d5ee994de81c24ce9f9a.png" />
            </div>
            <div className="p-max">
              <span className="label ">QLD</span>
              <h6>TAdventure Cairns and
              Beyond </h6>
              <p>10% discount to most
Tours for Tiny away
Guests</p>
              <p>Promocode: <b>adventurecairns10</b></p>
            </div>
          </div>
        </div>


        <div className="col-3">
          <div className="cont-text-mid">
            <div className="box-logo">
              <img src="https://tinyawaypartners.my.canva.site/media/b680b91f8413bec93eb6e80731b8d4b3.png" />
            </div>
            <div className="p-max">
              <span className="label color-label-1">NSW</span>
              <h6>Real Sydney Tours</h6>
              <p>5% Discount to most tours
for Tiny Away guests</p>
              <p>Promocode: <b>Realsydney5</b></p>
            </div>
          </div>
        </div>


        <div className="col-3">
          <div className="cont-text-mid">
            <div className="box-logo">
              <img src="https://tinyawaypartners.my.canva.site/media/2e81f414decaf3b472183e195a532a20.png" />
            </div>
            <div className="p-max">
              <span className="label color-label-1">NSW</span>
              <h6>Real Byron Bay Tours</h6>
              <p>5% Discount to most tours
              for Tiny Away guests</p>
              <p>Promocode: <b>Realbyronbay5</b></p>
            </div>
          </div>
        </div>





      </div>
      </div>
    );
  };
  const renderPageOnscroll5 = () => {
    return (
      
      <div className="container" id="page-6">
      <div className="row row-flex">
        <div className="col-3 color-yellow"><h1><div>Restaurant / Cafe / Bar</div></h1></div>
        <div className="col-3">
        <div className="coming-soon">Coming soon</div>
        </div>


        <div className="col-3">
        <div className="coming-soon">Coming soon</div>
        </div>


        <div className="col-3">
        <div className="coming-soon">Coming soon</div>
        </div>





      </div>
      </div>
    );
  };
  const renderPageOnscroll6 = () => {
    return ( 
      <div className="container" id="page-4">
      <div className="row row-flex">
        <div className="col-3 color-yellow"><h1><div>Entertainment</div></h1></div>
        <div className="col-3">
          <div className="cont-text-mid">
            <div className="box-logo">
              <img src="https://tinyawaypartners.my.canva.site/media/b7b8497b4380dda3f9251dd428d0cb29.jpg" />
            </div>
            <div className="p-max">
              <span className="label">QLD</span>
              <h6>Petama Entertainment</h6>
              <p>10% discount on DJ
              services.</p>
              <p>Promocode: <b>Petama10</b></p>
            </div>
          </div>
        </div>


        <div className="col-3">
        <div className="coming-soon">Coming soon</div>
        </div>


        <div className="col-3">
        <div className="coming-soon">Coming soon</div>
        </div>





      </div>
      </div>
    );
  };
  return (
    <div className={`nc-PagePartners overflow-hidden relative ${className}`} data-nc-id="PagePartners">

      <div >
        {renderCardMenu()}

        {renderPageOnscroll0()}
        {renderPageOnscroll1()}
        {renderPageOnscroll2()}
        {renderPageOnscroll3()}
        {renderPageOnscroll4()}
        {renderPageOnscroll5()}
        {renderPageOnscroll6()}

      </div>

    </div>

  );
};

export default PagePartners;
